export const GET_ALL_SETUP_THEMES_QK = "setup-themes-get-all";
export const GET_SETUP_THEME_QK = "setup-themes-get";
